
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.32 7H11.68A1.68 1.68 0 0010 8.68v10.64A1.68 1.68 0 0011.68 21h10.64A1.69 1.69 0 0024 19.32V8.68A1.68 1.68 0 0022.32 7zM23 19.32a.68.68 0 01-.68.68H11.68a.68.68 0 01-.68-.68V8.68a.68.68 0 01.68-.68h10.64a.68.68 0 01.68.68z"}}),_c('path',{attrs:{"d":"M13.1 10.93h7.8a.5.5 0 000-1h-7.8a.5.5 0 100 1zm.97 2.42h-1.3a.5.5 0 000 1h1.3a.5.5 0 000-1zm3.58 0h-1.3a.5.5 0 000 1h1.3a.5.5 0 000-1zm3.58 0h-1.3a.5.5 0 000 1h1.3a.5.5 0 000-1zm0 3.23h-1.3a.5.5 0 000 1h1.3a.5.5 0 000-1zm-3.58 0h-1.3a.5.5 0 000 1h1.3a.5.5 0 000-1zm-3.58 0h-1.3a.5.5 0 000 1h1.3a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M23.5 23H1V.5a.5.5 0 00-1 0v23a.5.5 0 00.5.5h23a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M3 15a.5.5 0 00.34-.14L8.76 9.8a.5.5 0 00-.68-.73l-5.42 5.07A.5.5 0 003 15zm16.62-8.82a.5.5 0 00.4-.2L22.4 2.8a.5.5 0 00-.8-.6l-2.38 3.18a.5.5 0 00.4.8z"}})])
          )
        }
      }
    